import DtoReferencial from './DtoReferencial'

export default class DtoFieldMode extends DtoReferencial {
    constructor(obj) {
        super(obj)
    }
}
